var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSkills = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 33,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#A635B0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.667,
  d: "m21.236 17.187 2.02 11.368a.667.667 0 0 1-1.08.626L17.402 25.6a1.33 1.33 0 0 0-1.596 0l-4.78 3.581a.666.666 0 0 1-1.08-.625l2.018-11.368"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#A635B0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.667,
  d: "M16.6 18.667a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
})));
export { SvgSkills as ReactComponent };
export default __webpack_public_path__ + "28dbbbed989015dcc3cd4a1f8e016bc0.svg";